import { Component, Input, OnInit } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";

import {
  AngularFirestore,
  AngularFirestoreCollection,
} from "@angular/fire/firestore";

import { Observable } from "rxjs";

import { GroceryService } from "../services/grocery/grocery.service";
import { StyleService } from "../services/style/style.service";
import { StoreName } from "../models/store";
import { Grocery } from "../models/grocery";

@Component({
  selector: "app-costco",
  templateUrl: "./costco.component.html",
  styleUrls: ["./costco.component.scss"],
})
export class CostcoComponent implements OnInit {
  createForm = new FormGroup({
    item: new FormControl(""),
  });
  costcoCollection: AngularFirestoreCollection<Grocery>;
  costcoItems: Observable<Grocery[]>;
  @Input()
  get showDeleted() {
    return this._showDeleted;
  }
  set showDeleted(showDeleted: boolean) {
    this._showDeleted = showDeleted;
    this.selectItems();
  }

  private _showDeleted = false;
  deletedItems = [];

  constructor(
    private afs: AngularFirestore,
    private groceryService: GroceryService,
    private styleService: StyleService
  ) {
    this.selectItems();
  }

  ngOnInit(): void {}

  selectItems() {
    this.costcoCollection = this.afs.collection<Grocery>("CostcoItems", (ref) =>
      ref.orderBy("value")
    );
    this.costcoItems = this.costcoCollection.valueChanges();
    this.deletedItems = this.groceryService.getDeleted(StoreName.COSTCO);
  }

  async addItem() {
    try {
      const value = this.createForm.controls.item.value;
      await this.groceryService.addItem(value, this.costcoCollection);
      this.createForm.controls.item.reset();
    } catch (error) {
      console.log(error);
      alert(error);
    }
  }

  async linethrough(costcoItem: Grocery) {
    try {
      await this.styleService.linethrough(costcoItem, this.costcoCollection);
    } catch (error) {
      console.log(error);
      alert(error);
    }
  }

  getLineThrough(costcoItem: Grocery) {
    try {
      return this.styleService.getLineThrough(costcoItem);
    } catch (error) {
      console.log(error);
      alert(error);
    }
  }

  getColor(costcoItem: Grocery) {
    return this.styleService.getColor(costcoItem, StoreName.COSTCO);
  }

  async restoreItem(costcoItem: Grocery) {
    try {
      await this.groceryService.restoreItem(
        costcoItem,
        this.costcoCollection,
        StoreName.COSTCO
      );
      this.deletedItems = this.groceryService.getDeleted(StoreName.COSTCO);
    } catch (error) {
      console.log(error);
      alert(error);
    }
  }

  async deleteItem(costcoItem: Grocery) {
    try {
      await this.groceryService.deleteItem(
        costcoItem,
        this.costcoCollection,
        StoreName.COSTCO
      );
      this.deletedItems = this.groceryService.getDeleted(StoreName.COSTCO);
    } catch (error) {
      console.log(error);
      alert(error);
    }
  }
}
